import { render, staticRenderFns } from "./setpasswd.vue?vue&type=template&id=07d55164&scoped=true"
import script from "./setpasswd.vue?vue&type=script&lang=js"
export * from "./setpasswd.vue?vue&type=script&lang=js"
import style0 from "./setpasswd.vue?vue&type=style&index=0&id=07d55164&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d55164",
  null
  
)

export default component.exports